"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const featureFlagsDetailData_1 = require("../../fragments/featureFlagsDetailData");
exports.isUserTokenValid = graphql_tag_1.default `
  query isUserTokenValid(
    $token: String!,
    $key: String!
  ) {
    isUserTokenValid(
      token: $token,
      key: $key
    )
       {
      id
      email
      fullName
      passwordResetTokenExpiresAt
      magicLinkTokenExpiresAt
    }
  }
`;
exports.user = graphql_tag_1.default `
  query userDetail($id: ID!) {
    user(id: $id) {
      id
      email
      fullName
      hasPassword
      isAppAdmin
      featureFlagOverrides {
        ...featureFlagsDetailData
      }
      workspaceMemberships {
        id
        isActive
        workspace {
          id
          name
        }
      }
      latestWorkspace {
        id
        name
      }
      latestInvitation {
        id
      }
      acceptedInvite {
        id
      }
      invites {
        id
        createdAt
        emailHtml
        usedToSignupAt
        error
      }
    }
  }
  ${featureFlagsDetailData_1.featureFlagsDetailData}
`;
exports.userWithLatestInvite = graphql_tag_1.default `
  query userWithLatestInvite($id: ID!) {
    user(id: $id) {
      id
      latestInvitation {
        id
        emailHtml
      }
    }
  }
`;
exports.users = graphql_tag_1.default `
  query users(
    $workspaceId: ID,
    $skip: Int,
    $take: Int,
    $isAppAdmin: Boolean,
    $searchQuery: String
  ) {
    usersCount(
      workspaceId: $workspaceId,
      isAppAdmin: $isAppAdmin,
      searchQuery: $searchQuery
    )
    users(
      workspaceId: $workspaceId,
      skip: $skip,
      take: $take,
      isAppAdmin: $isAppAdmin,
      searchQuery: $searchQuery
    ) {
      id
      email
      fullName
      deleted
      hasPassword
      archived
      isAppAdmin
      createdAt
      updatedAt
    }
  }
`;
exports.currentUser = graphql_tag_1.default `
  query currentUser {
    currentUser {
      id
      email
      fullName
      isAppAdmin
      workspaceMemberships {
        id
        isWorkspaceAdmin
        workspace {
          id
          name
          enabledIntegrationClasses
          featureFlagOverrides {
            ...featureFlagsDetailData
          }
        }
      }
      currentWorkspaceMembership {
        id
        isWorkspaceAdmin
        workspace {
          id
          name
          enabledIntegrationClasses
          featureFlagOverrides {
            ...featureFlagsDetailData
          }
        }
      }
    }
  }
  ${featureFlagsDetailData_1.featureFlagsDetailData}
`;
//# sourceMappingURL=users.js.map